module.exports = __webpack_public_path__ + "img/murloc_champion_small.3d572970.png";